// PLACEHOLDER: This file establishes the directory structure only.
// To be implemented in a future PR.

import {Condition, FilterCondition} from "./filterTypes"

/**
 * Converts technical condition values to user-friendly descriptions
 * with clear visual separation between field name and condition
 *
 * @param condition The filter condition
 * @returns An object with formatted field and condition parts
 */
export function formatConditionForDisplay(condition: FilterCondition): {
  fieldLabel: string
  conditionLabel: string
} {
  // Get field name for context
  const fieldName = condition.field
  let conditionText = ""

  // Format based on condition type
  switch (condition.condition) {
    case "is":
      conditionText = "is:"
      break

    case "oneOf":
      if (condition.threshold && condition.threshold > 1) {
        conditionText = `at least ${condition.threshold} of:`
      } else {
        conditionText = "one of the following:"
      }
      break

    case "contains":
      conditionText = "contains:"
      break

    default:
      // Return the original if unknown condition
      conditionText = condition.condition
      break
  }

  return {
    fieldLabel: fieldName,
    conditionLabel: conditionText,
  }
}

/**
 * Determines if an action should be treated as "Archive & Mark Sensitive"
 * This helps infer the correct action type based on the action name and sensitivity level
 *
 * @param action The action type string
 * @param sensitivity The sensitivity level (0 or higher)
 * @returns A boolean indicating if the action should be treated as sensitive archiving
 */
export function isArchiveAndSensitive(
  action: string,
  sensitivity: number
): boolean {
  // If action is archive and sensitivity level > 0
  return (
    action.includes("archive") &&
    !action.includes("no-archive") &&
    sensitivity > 0
  )
}

/**
 * Get action text based on the action type and sensitivity
 * This provides a user-friendly description of what happens to messages
 *
 * @param action The action type string
 * @param sensitivity The sensitivity level (0 or higher)
 * @returns The appropriate action text to display
 */
export function getActionText(action: string, sensitivity: number): string {
  if (isArchiveAndSensitive(action, sensitivity)) {
    return "Archive & Mark Sensitive"
  } else if (action.includes("no-archive")) {
    return "Do Not Archive"
  } else if (action.includes("archive")) {
    return "Archive"
  } else {
    return "Process"
  }
}
